import { useState } from "react"
import { X, Calendar, Shield, ArrowRight, Search } from "lucide-react"
import Button from "../../Components/OnBoarding/Button"
import Header from "./Header"
import Footer from "./Footer"
import fire from "../../assets/OnBoarding/Fire.svg"
import Building from "../../assets/OnBoarding/Building.svg"
import Book from "../../assets/OnBoarding/Book.svg"
import { useNavigate } from "react-router-dom"

export default function Component() {
  const [showModal, setShowModal] = useState(true)
  const navigate = useNavigate()

  return (
    <div className="min-h-screen overflow-x-hidden bg-white relative">
      {/* Header */}
      <Header/>

      {/* Main Content */}
      <main className="flex items-center justify-center min-h-[calc(100vh-80px)] p-4">
        <div className="bg-white rounded-xl shadow-lg p-8 w-full max-w-md">
          {/* Purple Icon */}
          <div className="mb-6">
            <div className="w-12 h-12 flex items-center justify-center">
              <img src={Building} alt="Building Icon" className="w-12 h-12" />
            </div>
          </div>

          {/* What's next section */}
          <div>
            <h1 className="text-2xl font-bold text-gray-900 mb-4">{"What's next?"}</h1>
            <p className="text-gray-600 mb-8">
              Choose your next step to make the most of your Coded Estate experience.
            </p>

            {/* Book now button - Centered and same size */}
            <div className="flex justify-center mb-6">
              <Button className="w-full max-w-sm h-12 px-4 py-3 gap-2 rounded-lg bg-gradient-to-b from-[rgba(255,255,255,0.18)] to-transparent bg-[#5B1DEE] shadow-[2px_2px_6px_0px_#BBC3CE99,-2px_-2px_6px_0px_#FDFFFFCC] text-white font-medium flex items-center justify-center"
                              onClick={()=> navigate("/rent/all")}
              >
                <span className="flex items-center gap-2">
                  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M18 17.5005L14.3833 13.8838"
                      stroke="white"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M14.3807 4.45262C16.9842 7.05611 16.9842 11.2772 14.3807 13.8807C11.7772 16.4842 7.55611 16.4842 4.95262 13.8807C2.34913 11.2772 2.34913 7.05611 4.95262 4.45262C7.55611 1.84913 11.7772 1.84913 14.3807 4.45262"
                      stroke="white"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  Start Exploring
                </span>
              </Button>
            </div>

            {/* OR with lines */}
            <div className="flex items-center mb-6">
              <div className="flex-1 h-px bg-gray-300"></div>
              <div className="px-4 text-gray-400 text-sm">OR</div>
              <div className="flex-1 h-px bg-gray-300"></div>
            </div>

            <p className="text-gray-600 mb-4 text-center">Explore stays and start your next adventure.</p>

            {/* Verify me button - Same size as Book now */}
            <Button
              variant="outline"
              className="w-full max-w-sm h-12 mx-auto bg-gray-900 text-white hover:bg-gray-800 border-gray-900 rounded-lg mb-6 flex items-center justify-center"
              onClick={()=>navigate("/dashboard/profile?mode=traveler")}
            >
              <span className="flex items-center gap-2">
                <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.5 21.75H19.5C21.02 21.75 22.25 20.52 22.25 19V16C22.25 15.59 21.91 15.25 21.5 15.25C21.09 15.25 20.75 15.59 20.75 16V19C20.75 19.69 20.19 20.25 19.5 20.25H16.5C16.09 20.25 15.75 20.59 15.75 21C15.75 21.41 16.09 21.75 16.5 21.75ZM5.5 21.75H8.5C8.91 21.75 9.25 21.41 9.25 21C9.25 20.59 8.91 20.25 8.5 20.25H5.5C4.81 20.25 4.25 19.69 4.25 19V16C4.25 15.59 3.91 15.25 3.5 15.25C3.09 15.25 2.75 15.59 2.75 16V19C2.75 20.52 3.98 21.75 5.5 21.75ZM20.75 8C20.75 8.41 21.09 8.75 21.5 8.75C21.91 8.75 22.25 8.41 22.25 8V5C22.25 3.48 21.02 2.25 19.5 2.25H16.5C16.09 2.25 15.75 2.59 15.75 3C15.75 3.41 16.09 3.75 16.5 3.75H19.5C20.19 3.75 20.75 4.31 20.75 5V8ZM2.75 8C2.75 8.41 3.09 8.75 3.5 8.75C3.91 8.75 4.25 8.41 4.25 8V5C4.25 4.31 4.81 3.75 5.5 3.75H8.5C8.91 3.75 9.25 3.41 9.25 3C9.25 2.59 8.91 2.25 8.5 2.25H5.5C3.98 2.25 2.75 3.48 2.75 5V8ZM8.25 17.5C8.25 15.16 10.16 13.25 12.5 13.25C14.84 13.25 16.75 15.16 16.75 17.5C16.75 17.91 17.09 18.25 17.5 18.25C17.91 18.25 18.25 17.91 18.25 17.5C18.25 15.2172 16.9121 13.2404 14.9794 12.3127C15.7584 11.6254 16.25 10.6197 16.25 9.5C16.25 7.43 14.57 5.75 12.5 5.75C10.43 5.75 8.75 7.43 8.75 9.5C8.75 10.6197 9.24159 11.6254 10.0206 12.3127C8.08791 13.2404 6.75 15.2172 6.75 17.5C6.75 17.91 7.09 18.25 7.5 18.25C7.91 18.25 8.25 17.91 8.25 17.5ZM10.25 9.5C10.25 10.74 11.26 11.75 12.5 11.75C13.74 11.75 14.75 10.74 14.75 9.5C14.75 8.26 13.74 7.25 12.5 7.25C11.26 7.25 10.25 8.26 10.25 9.5Z"
                    fill="white"
                  />
                </svg>
                Verify me
              </span>
            </Button>

            <p className="text-sm text-gray-500 mb-6 text-center">
              Complete your verification to unlock full features.
            </p>

            {/* Line above dashboard link */}
            <div className="w-full h-px bg-gray-300 mb-4"></div>

            {/* Dashboard link */}
            <div className="flex justify-center">
              <button className="text-[#5B1DEE] underline hover:text-purple-700 font-medium flex items-center gap-1"
              onClick={()=>navigate("/dashboard/host/mint")}
              >
                Start Hosting Properties
                <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M9.1665 5.5L14.9999 5.5002L14.9998 11.3333"
                    stroke="#5B1DEE"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M5 15.5L14.9999 5.5"
                    stroke="#5B1DEE"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <Footer/>

      {/* Congratulations Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-xl shadow-2xl p-8 max-w-sm w-full relative">
            {/* Close button */}
            <button
              onClick={() => setShowModal(false)}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
            >
              <X className="w-5 h-5" />
            </button>

            {/* Fire emoji */}
            <div className="text-center">
               <div className="text-center mb-4 flex justify-center">
                    <img src={fire} alt="Fire" />
                  </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Congratulations</h2>
              <p className="text-gray-600 mb-6">{"You're now fully onboarded and ready to experience Coded Estate!"}</p>

              {/* Progress bar */}
              <div className="mb-4">
                <div className="w-full bg-gray-200 rounded-full h-2 mb-2">
                  <div className="bg-[#5B1DEE] h-2 rounded-full w-full"></div>
                </div>
                <span className="text-sm text-[#5B1DEE] font-medium">Onboarding Complete (100%)</span>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
